import {useParams} from 'react-router-dom';
import LogbookReview from '../../components/LogbookReview/LogbookReview';
import useLogbook from '@/hooks/useLogbook';
import './AdminLogbook.scss';
import studiesConst from '@/constants/studiesConst';
import StopProgressForm from '@/components/StopProgressForm/StopProgressForm';
import {useState} from 'react';

function AdminLogbook() {
  const {assessmentId} = useParams();
  const {logbook, mutate, isLoading} = useLogbook({assessmentId});
  const [isStopProgressActive, setIsStopProgressActive] = useState(false);

  const isStudyCancelled =
    logbook?.assessmentStatus === studiesConst.assessmentStatus.pendingCancel ||
    logbook?.assessmentStatus === studiesConst.assessmentStatus.invalid;

  if (!isStopProgressActive && isStudyCancelled && !isLoading) {
    setIsStopProgressActive(true);
  }

  return (
    <main className="container">
      <div className="dashboard admin-logbook">
        <div className="row">
          <div className="col-12">
            <div className="d-flex justify-content-between align-items-center">
              <div className="name mb-3">Cuadro de Avance</div>
              {!isStudyCancelled && !isLoading && !isStopProgressActive && (
                <button
                  type="button"
                  className="btn btn-danger progress-btn progress-btn-stop"
                  onClick={() => setIsStopProgressActive(true)}
                >
                  Detener Proceso
                </button>
              )}
            </div>
            <StopProgressForm
              isStopProgressActive={isStopProgressActive}
              setIsStopProgressActive={setIsStopProgressActive}
              isStudyCancelled={isStudyCancelled}
              isPendingCancel
            />
            <LogbookReview logbook={logbook} mutate={mutate} />
          </div>
        </div>
      </div>
    </main>
  );
}

export default AdminLogbook;
